import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=2e8da95a&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDropZone.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=2e8da95a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8da95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8da95a')) {
      api.createRecord('2e8da95a', component.options)
    } else {
      api.reload('2e8da95a', component.options)
    }
    module.hot.accept("./FileDropZone.vue?vue&type=template&id=2e8da95a&scoped=true", function () {
      api.rerender('2e8da95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/fileUploadModal/FileDropZone.vue"
export default component.exports